import { VaultFile, VaultFileSource } from '../../../../types/vault.types';

// A document sent for signature through DocuSign stays as it was signed: no rename, no delete.
export const isVaultDocusignFile = (file: Pick<VaultFile, 'fileSource' | 'signatureId'>): boolean =>
  file.fileSource === VaultFileSource.DOCUSIGN || Boolean(file.signatureId);
